class Authorization {
    async resetPassword(userId: string, token: string, pass: string): Promise<number> {
        const response = await fetch(`${process.env.VUE_APP_MODEL_URL}/user/reset_password?userId=${encodeURIComponent(userId)}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': token },
            body: JSON.stringify({ pass: pass })
        })
        return response.status
    }
}
export default Authorization
